import { render } from "./FolderStructure.vue?vue&type=template&id=7f38bbc0&scoped=true&ts=true"
import script from "./FolderStructure.vue?vue&type=script&lang=ts"
export * from "./FolderStructure.vue?vue&type=script&lang=ts"

import "./FolderStructure.vue?vue&type=style&index=0&id=7f38bbc0&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f38bbc0"]])

export default __exports__